import React, { useState } from 'react';
import T from 'prop-types';

import { BaseCsvExportButton } from './BaseCsvExportButton';

import axios from '../../../configs/axios';
import { downloadBlobWorkaround } from '../../../utils/download-blob';

export const AsyncCsvExportButton = ({
  id = 'async-csv-export-button',
  url,
  method = 'post',
  body,
  defaultFilename,
  onDownloadSuccess,
  onVisibleChange,
  ...restBaseCsvExportButtonProps
}) => {
  const [downloading, setDownloading] = useState(false);

  const handleCsvDownload = () => {
    if (restBaseCsvExportButtonProps.disabled) return;

    setDownloading(true);

    axios[method](url, body, { responseType: 'blob' })
      .then((response) => {
        const contentDisposition = response.headers['content-disposition'];
        const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
        const filename = filenameMatch ? filenameMatch[1] : defaultFilename;

        if (response.data.size) {
          downloadBlobWorkaround(response.data, filename);
        }

        setDownloading(false);
        if (onDownloadSuccess) onDownloadSuccess();
      })
      .catch(() => setDownloading(false));
  };

  return (
    <BaseCsvExportButton
      id={id}
      loading={downloading}
      {...restBaseCsvExportButtonProps}
      onClick={handleCsvDownload}
      onVisibleChange={onVisibleChange}
    />
  );
};

AsyncCsvExportButton.propTypes = {
  id: T.string,
  url: T.string.isRequired,
  method: T.string,
  body: T.object,
  defaultFilename: T.string,
  onDownloadSuccess: T.func,
  onVisibleChange: T.func,
};
